<template>
  <div class="bill" :style="{ backgroundImage: branch_watermark }">
    <div
      style="width: 100%; margin-bottom: 8px"
      class="align-center justify-center row-reversable"
    >
      <div
        style="
          flex: 1;
          display: flex;
          font-size: 12px;
          flex-direction: column;
          justify-content: center;
        "
        class="align-start"
      >
        <img
          alt="SO"
          class="bill_logo"
          :src="branch_logo"
          style="width: 2cm; height: auto"
        />
      </div>
      <div style="display: flex; justify-content: center; align-items: center">
        <div class="font-weight-bold" style="text-align: center">
          <div class="font-weight-bold bill_title">{{ branch_fa_name }}</div>
          <div class="font-weight-bold bill_title">{{ LONG_APP_NAME }}</div>
          <div class="font-weight-bold bill_title">
            {{ $t("receive_transfer_slip") }}
          </div>
        </div>
      </div>
      <div
        style="
          flex: 1;
          display: flex;
          font-size: 12px;
          flex-direction: column;
          justify-content: center;
        "
        class="align-end"
      >
        <span>
          <span class="pcf-label">{{ $t("transfer_number") }}: </span>
          <span class="pcf-text"> {{ transfer.number }}</span>
        </span>
        <span>
          <span class="pcf-label">{{ $t("source") }}: </span>
          <span class="pcf-text">{{ sender.name }}</span>
        </span>
        <span>
          <span class="pcf-label">{{ $t("date") }}: </span>
          <span class="pcf-text">{{ transfer.date }} {{ transfer.time }}</span>
        </span>
        <span>
          <span class="pcf-label">{{ $t("persian_date") }}: </span>
          <span class="pcf-text">{{
            transfer.date | persianDateFilter(true)
          }}</span>
        </span>
      </div>
    </div>
    <table class="greyGridTable bill-table">
      <tbody class="lr--text">
        <tr>
          <td
            colspan="100%"
            class="bill_color white--text pcf-label"
            style="font-size: 13px; font-weight: 500"
          >
            <span>
              {{ $t("sender_details") }}
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span class="pcf-label">{{ $t("reg_no") }}: </span>
            <span class="mx-2 pcf-text">{{ transfer.details.reg_id }}</span>
          </td>
          <td>
            <span class="pcf-label">{{ $t("full_name") }}: </span>
            <span class="mx-2 pcf-text">{{ transfer.details.name }}</span>
          </td>
          <td>
            <span class="pcf-label">{{ $t("father_name") }}: </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.father_name
            }}</span>
          </td>
          <td>
            <span class="pcf-label">{{ $t("nationality") }}: </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.nationality
            }}</span>
          </td>
        </tr>
        <tr>
          <td>
            <span class="pcf-label">{{ $t(transfer.details.doctype) }}: </span>
            <span class="mx-2 pcf-text">{{ transfer.details.docno }}</span>
          </td>
          <td>
            <span class="pcf-label">{{ $t("issue_date") }}: </span>
            <span class="mx-2 pcf-text">{{ transfer.details.issue_date }}</span>
          </td>
          <td>
            <span class="pcf-label">{{ $t("expire_date") }}: </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.expire_date
            }}</span>
          </td>
          <td>
            <span class="pcf-label">{{ $t("place_of_birth") }}: </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.place_of_birth
            }}</span>
          </td>
        </tr>

        <tr>
          <td colspan="2">
            <span class="pcf-label">{{ $t("date_of_birth") }}: </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.date_of_birth
            }}</span>
          </td>
          <td colspan="2">
            <span class="pcf-label">{{ $t("phones") }}: </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.pretty_phones
            }}</span>
          </td>
        </tr>
       
       
        <!-- Receiver Details -->
        <tr>
          <td colspan="100%" class="white" style="padding-top: 5px"></td>
        </tr>
        <tr class="mt-2">
          <td
            colspan="100%"
            class="bill_color white--text pcf-label"
            style="font-size: 13px; font-weight: 500"
          >
            <span>
              {{ $t("receiver_details") }}
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span class="pcf-label">{{ $t("full_name") }}: </span>
            <span class="pcf-text">
              {{ transfer.details.receiver_name }}
            </span>
          </td>
          <td>
            <span class="pcf-label">{{ $t("father_name") }}: </span>
            <span class="pcf-text">
              {{ transfer.details.receiver_father_name }}
            </span>
          </td>
          <td>
            <span class="pcf-label">{{ $t("nationality") }}: </span>
            <span class="pcf-text">
              {{ transfer.details.receiver_nationality }}
            </span>
          </td>
          <td>
            <span class="pcf-label">{{ $t("occupation") }}: </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.receiver_occupation
            }}</span>
          </td>
        </tr>

        <tr>
          <td>
            <span class="pcf-label"
              >{{ $t(transfer.details.receiver_doctype) }}:
            </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.receiver_docno
            }}</span>
          </td>
          <td>
            <span class="pcf-label">{{ $t("issue_date") }}: </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.receiver_issue_date
            }}</span>
          </td>
          <td>
            <span class="pcf-label">{{ $t("expire_date") }}: </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.receiver_expire_date
            }}</span>
          </td>
          <td>
            <span class="pcf-label">{{ $t("place_of_birth") }}: </span>
            <span class="pcf-text">
              {{ transfer.details.receiver_place_of_birth }}
            </span>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <span class="pcf-label">{{ $t("date_of_birth") }}: </span>
            <span class="pcf-text">
              {{ transfer.details.receiver_date_of_birth }}
            </span>
          </td>
          <td colspan="2">
            <span class="pcf-label">{{ $t("phones") }}: </span>
            <span class="pcf-text">
              {{ transfer.details.pretty_receiver_phones }}
            </span>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <span class="pcf-label">{{ $t("occupation") }}: </span>
            <span class="mx-2 pcf-text">{{ transfer.details.receiver_occupation }}</span>
          </td>
          <td colspan="2">
            <span class="pcf-label">{{ $t("relationship") }}: </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.receiver_relationship
            }}</span>
          </td>
        </tr>
         <tr>
          <td colspan="2">
            <span class="pcf-label">{{ $t("source_of_fund") }}: </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.receiver_source_of_fund
            }}</span>
          </td>
          <td colspan="2">
            <span class="pcf-label">{{ $t("purpose_of_transaction") }}: </span>
            <span class="mx-2 pcf-text">{{
              transfer.details.receiver_purpose_of_transaction
            }}</span>
          </td>
        </tr>
         <tr>
          <td colspan="4">
            <span class="pcf-label">{{ $t("address") }}: </span>
            <span class="mx-2 pcf-text">{{ transfer.details.receiver_address }}</span>
          </td>
        </tr>

        <!-- Transaction Details -->

        <tr>
          <td colspan="100%" class="white" style="padding-top: 5px"></td>
        </tr>
        <tr class="mt-2">
          <td
            colspan="100%"
            class="bill_color white--text pcf-label"
            style="font-size: 13px; font-weight: 500"
          >
            <span>
              {{ $t("transaction_details") }}
            </span>
          </td>
        </tr>
        <tr>
          <td colspan="4">
            <span class="pcf-label">{{ $t("amount") }}: </span>
            <span class="pcf-text capitalize">
              {{
                transfer.amount
                  | currency({ symbol: smbl(transfer.currency_id, isRTL) })
              }}
              ({{ transfer.amount | toWord }})
            </span>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <span class="pcf-label">{{ $t("commission") }}: </span>
            <span class="pcf-text capitalize">
              {{
                transfer.commission_amount
                  | currency({
                    symbol: smbl(transfer.commission_currency_id, isRTL),
                  })
              }}
              ({{ transfer.commission_amount | toWord }})
            </span>
          </td>
          <td colspan="2">
            <span class="pcf-label">{{ $t("paid_commission") }}: </span>
            <span class="pcf-text capitalize">
              {{
                transfer.paid_commission_amount
                  | currency({
                    symbol: smbl(transfer.paid_commission_currency_id, isRTL),
                  })
              }}
              ({{ transfer.paid_commission_amount | toWord }})
            </span>
          </td>
        </tr>
        <tr>
          <!-- <td colspan="2" >
            <span class="pcf-label">{{$t("risk_category")}}: </span>
            <span class="pcf-text">{{transfer.risk_category}}</span>
          </td> -->
          <td colspan="4">
            <span class="pcf-label">{{$t("suction_checked")}}: </span>
            <span class="pcf-text">{{transfer.suction_checked ? "Yes":"No"}}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <p class="bill-footer lr--text mb-5">
      <strong> {{ $t("description") }}: {{ transfer.description }}</strong>
    </p>
    <bill-footer :userProp="transfer.user"></bill-footer>
  </div>
</template>
<script>
export default {
  name: "receive-transfer-bill",
  props: {
    transfer: {
      default: () => ({ details: {} }),
    },
    receiver: { default: () => {} },
    sender: { default: () => {} },
  },
  computed: {
    user() {
      return this.$store.getters["AuthModule/current_user"]["user"];
    },
  },
};
</script>